import { useState, useEffect } from 'react'
import '../styles/About.css'
import fetchApi, { API_ENDPOINTS } from '../utils/api'

const About = () => {
  const [aboutContent, setAboutContent] = useState('')

  useEffect(() => {
    const fetchContent = async () => {
      try {
        // Fetch about content
        const aboutResponse = await fetchApi(`${API_ENDPOINTS.main}?section=about`)
        if (aboutResponse && aboutResponse.contents) {
          setAboutContent(aboutResponse.contents)
        }
      } catch (error) {
        console.error('Failed to fetch content:', error)
      }
    }

    fetchContent()
  }, [])

  return (
    <section id="about" className="about">
      <div className="section-content">
        <h2>ABOUT</h2>
        <div className="about-content">
          <div className="about-text">
            <p>
              {aboutContent}
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default About
